import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/ts/L10n/L10n';


export namespace ResourceGovernanceGridCells {
  export function resourceGovernanceLimitFormatter(propertyName: string): React.StatelessComponent<BodyCell.Props> {
    return (props: BodyCell.Props) => {
      const limit = props.row.data[propertyName];
      const limitLabel = limit === undefined ? Messages.resourceGovernanceNoLimitValue() : L10n.localizedCount(limit);
      return React.createElement('span', {}, limitLabel);
    };
  }
}
